import { Component } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-calculators',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './calculators.component.html',
  styleUrl: './calculators.component.css'
})
export class CalculatorsComponent {


  calcType: string = "spreader"; //default, could be foliar or conversion as well
  particleSizeId: number = 0;
  particleSizes: any[] = [];
  spreaderId: number = 0;
  spreaders: any[] = [];
  spreaderSelected: any = null;
  speed: number = 0;
  speeds: any[] = [];
  productDensity: number = 0;
  element: string = "";
  elements: any[] = [];
  productPerThousand: number = 0;
  nitrogenPerThousand: number = 0;
  potassiumPerThousand: number = 0;
  nitrogenPercent: number = 0;
  potassiumPercent: number = 0;
  showSpeed: boolean = true;
  setting: string = "";
  elementPercent: number = 0;
  pounds: number = 0;

  foliarItems: any[] = [];
  foliarItemNmbr: string = "";
  acresPerTank: number = 0;
  jugsPerTank: number = 0;
  foliarResults: any[] = [];

  toOptions: any[] = [];
  fromInput: number = 0;
  toResult: number = 0;
  selectedFromConversion: string = "";
  selectedToConversion: string = "";
  previousClassSelected: string = "";

  displayFailure: boolean = false;
  failureMessage: string = "";

  baseFilesPath: string = environment.azureBlobStorageURL + environment.baseFilesPathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Calculator/";

  constructor(private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public myHarrellsService: MyharrellsService) { }

  ngOnInit(): void {

    this.calcType = "spreader"; //default, could be foliar or conversion as well

    if (typeof document !== 'undefined' && document.location.search != '') {
      let queryString = document.location.search;
      let urlParams = new URLSearchParams(queryString);
      this.calcType = urlParams.get('calcType');
    }



    //meta tags for SEO
    this.title.setTitle("Harrell’s Tools | Spreader Calculator & More");
    this.meta.updateTag({ name: 'description', content: "Access Harrell’s agronomic tools, including spreader, foliar, and conversion calculators. Need help? Contact us at contact@harrells.com." });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Tools | Spreader Calculator & More" });
    this.meta.updateTag({ property: 'og:description', content: "Access Harrell’s agronomic tools, including spreader, foliar, and conversion calculators. Need help? Contact us at contact@harrells.com." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here -  calculators" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here -  calculators" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Tools | Spreader Calculator & More" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Tools | Spreader Calculator & More" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Tools | Spreader Calculator & Mores" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Access Harrell’s agronomic tools, including spreader, foliar, and conversion calculators. Need help? Contact us at contact@harrells.com." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here -  calculators" });

    if (this.calcType == 'spreader') {
      this.DisplaySpreaderCalculator(); // this is the default when the page opens
    }
    else if (this.calcType == 'foliar') {
      this.DisplayFoliarCalculator(); // this is the default when the page opens
    }
    else if (this.calcType == 'conversion') {
      this.DisplayConversionCalculator(); // this is the default when the page opens
    }
  }

  DisplaySpreaderCalculator() {
    // this is the default when the page opens
    this.calcType = 'spreader';
    this.productDensity = 0;
    this.potassiumPerThousand = 0;
    this.nitrogenPerThousand = 0;
    this.productPerThousand = 0;
    this.nitrogenPercent = 0;
    this.potassiumPercent = 0;
    this.setting = "";
    this.spreaderId = 0; // default to the first spreader

    this.GetParticleSizes();
    this.particleSizeId = 0; // default to the first particle size
    this.GetSpreaderList(); // get the spreader list for the default size
    this.GetSpeeds();
    this.GetElements();
  }

  DisplayFoliarCalculator() {
    // this is the default when the page opens
    this.calcType = 'foliar';
    this.foliarItemNmbr = "";
    this.jugsPerTank = 0;
    this.acresPerTank = 0;
    this.GetFoliarItems();
  }

  GetFoliarItems() {
    this.dotComService.GetFoliarItems().subscribe((data: any) => {
      this.foliarItems = data;
    })
  }

  DisplayConversionCalculator() {
    // this is the default when the page opens
    this.calcType = 'conversion';
  }

  ParticleSizeChanged() {
    this.GetSpreaderList();
  }

  GetParticleSizes() {
    this.dotComService.GetParticleSizes().subscribe((data: any) => {
      this.particleSizes = [];
      this.particleSizes.push({ Id: 0, Size: "Select A Size" });
      for (let index = 0; index < data.length; index++) {
        this.particleSizes.push(data[index]);
      }
    });
  }

  SpreaderChanged() {
    //determine if the selected spreader needs to show the speed dropdown
    this.spreaderSelected = this.spreaders.filter(z => z.Id == this.spreaderId)[0];
    if (this.spreaderSelected.SpeedRequired && this.spreaderSelected.DefaultSpeed == 0) {
      this.showSpeed = true;
      this.speed = 0;
    }
    else {
      this.showSpeed = false;
    }

  }

  GetSpreaderList() {
    this.spreaders = [];
    this.dotComService.GetSpreaderList(this.particleSizeId).subscribe((data: any) => {
      this.spreaders.push({ Id: 0, Name: "Select A Particle Size First" });
      for (let index = 0; index < data.length; index++) {
        this.spreaders.push(data[index]);
      }
    })
  }

  GetSpeeds() {
    this.speeds = [];
    this.speeds.push({ Id: 0, Speed: "Select A Speed" });
    for (let index = 2.5; index <= 15; index += .5) {
      this.speeds.push({ Id: index, Speed: index });
    }
  }

  GetElements() {
    this.elements = [];
    this.elements.push({ Id: 'P', Name: "Product" });
    this.elements.push({ Id: 'N', Name: "Nitrogen" });
    this.elements.push({ Id: 'K', Name: "Potassium" });
    //default to the first element
    this.element = this.elements[0].Id;
  }

  Calculate() {
    this.displayFailure = false;
    this.failureMessage = "";

    if (this.calcType == 'spreader') {
      if (this.spreaderSelected == null || this.particleSizeId == 0 || this.spreaderId == 0 || this.productDensity == 0 ||
        (this.element == 'P' && this.productPerThousand == 0) ||
        (this.element == 'N' && this.nitrogenPerThousand == 0) ||
        (this.element == 'K' && this.potassiumPerThousand == 0) ||
        (this.showSpeed && this.speed == 0)) {
        this.displayFailure = true;
        this.failureMessage = "You failed to complete all the required fields.  Please try again.";
        return
      }
      //get the speed to use - depends on the spreader and its speed settings or the speed dropdown
      let speedToUse = 0;
      if (this.spreaderSelected.SpeedRequired && this.spreaderSelected.DefaultSpeed != 0) {
        speedToUse = this.spreaderSelected.DefaultSpeed;
      } else if (this.spreaderSelected.SpeedRequired && this.spreaderSelected.DefaultSpeed == 0) {
        speedToUse = this.speed; //this is the speed the user defined in the dropdown
      } else
        speedToUse = 0;


      if (this.element == 'P') {
        //element percent, pounds, product density, spreader id, speed
        this.dotComService.GetSpreaderCalculator(100, this.productPerThousand, this.productDensity, this.spreaderId, speedToUse).subscribe((data: any) => {
          this.setting = data[0].SpreaderSetting;
        })
      }
      else if (this.element == 'N') {
        //element percent, pounds, product density, spreader id, speed
        this.dotComService.GetSpreaderCalculator(this.nitrogenPercent, this.nitrogenPerThousand, this.productDensity, this.spreaderId, speedToUse).subscribe((data: any) => {
          this.setting = data[0].SpreaderSetting;
        })
      }
      else if (this.spreaderSelected == null || this.element == 'K') {
        //element percent, pounds, product density, spreader id, speed
        this.dotComService.GetSpreaderCalculator(this.potassiumPercent, this.potassiumPerThousand, this.productDensity, this.spreaderId, speedToUse).subscribe((data: any) => {
          this.setting = data[0].SpreaderSetting;
        })
      }

    }
    else if (this.calcType == 'foliar') {
      if (this.foliarItemNmbr == "" || this.jugsPerTank == 0 || this.acresPerTank == 0) {
        this.displayFailure = true;
        this.failureMessage = "You failed to complete all the required fields.  Please try again.";
        return
      }

      this.foliarResults = [];
      this.dotComService.GetFoliarCalculator(this.foliarItemNmbr, this.jugsPerTank, this.acresPerTank).subscribe((data: any) => {
        this.foliarResults = data;
      })
    }
    else if (this.calcType == 'conversion') {
    }
  }

  FromUOMDDChanged(e: any) {
    this.selectedFromConversion = e.target.value;
    if (e.target.selectedOptions[0].className != this.previousClassSelected) {
      this.previousClassSelected = e.target.selectedOptions[0].className;
      this.toOptions = [];
      if (e.target.selectedOptions[0].className == 'length') {
        this.toOptions.push({ class: 'length', value: 'inches', name: 'Inches' });
        this.toOptions.push({ class: 'length', value: 'feet', name: 'Feet' });
        this.toOptions.push({ class: 'length', value: 'yards', name: 'Yards' });
        this.toOptions.push({ class: 'length', value: 'miles', name: 'Miles' });
        this.toOptions.push({ class: 'length', value: 'centimeters', name: 'Centimeters' });
        this.toOptions.push({ class: 'length', value: 'meters', name: 'Meters' });
        this.toOptions.push({ class: 'length', value: 'kilometers', name: 'Kilometers' });
      } else if (e.target.selectedOptions[0].className == 'area') {
        this.toOptions.push({ class: 'area', value: 'acres', name: 'Acres' });
        this.toOptions.push({ class: 'area', value: 'squaremiles', name: 'Square Miles' });
        this.toOptions.push({ class: 'area', value: 'squarekilometers', name: 'Square Kilometers' });
      } else if (e.target.selectedOptions[0].className == 'volume') {
        this.toOptions.push({ class: 'volume', value: 'fluidounces', name: 'Fluid Ounces' });
        this.toOptions.push({ class: 'volume', value: 'quarts', name: 'Quarts' });
        this.toOptions.push({ class: 'volume', value: 'gallons', name: 'Gallons' });
      } else if (e.target.selectedOptions[0].className == 'weight') {
        this.toOptions.push({ class: 'weight', value: 'ounces', name: 'Ounces' });
        this.toOptions.push({ class: 'weight', value: 'pounds', name: 'Pounds' });
        this.toOptions.push({ class: 'weight', value: 'grams', name: 'Grams' });
        this.toOptions.push({ class: 'weight', value: 'kilograms', name: 'Kilograms' });
      } else if (e.target.selectedOptions[0].className == 'temperature') {
        this.toOptions.push({ class: 'temperature', value: 'farenheit', name: 'Farenheit' });
        this.toOptions.push({ class: 'temperature', value: 'celsius', name: 'Celsius' });
      } else if (e.target.selectedOptions[0].className == 'pressure') {
        this.toOptions.push({ class: 'pressure', value: 'poundsper1000ft²', name: 'Pounds Per 1000 ft²' });
        this.toOptions.push({ class: 'pressure', value: 'poundsperacre', name: 'Pounds Per Acre' });
      }
      this.selectedToConversion = this.toOptions[0].value
    }


    this.CalcResult()
  }

  ToUOMDDChanged(e: any) {
    this.selectedToConversion = e.target.value;
    this.CalcResult()
  }

  CalcResult() {
    if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 1;
    }
    else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * (1 / 12);
    }
    else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * (1 / 36);
    } else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * (1 / (5280 * 12));
    }
    else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 2.54;
    } else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * .0254;
    } else if (this.selectedFromConversion == 'inches' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * .0000254;
    }
    else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 12;
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput;
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * (1 / 3);
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * (1 / 5280);
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 30.48;
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * 0.3048;
    } else if (this.selectedFromConversion == 'feet' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * 0.0003048;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 36;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * 3;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * (3 / 5280);
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 91.44;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * .9144;
    } else if (this.selectedFromConversion == 'yards' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * .0009144;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 63360;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * 5280;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * (5280 / 3);
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 160934.4;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * 1609.344;
    } else if (this.selectedFromConversion == 'miles' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * 1.609344;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * .3937007874;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * .03280839895;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * .010936132983;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * .0000062137119224;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * .01;
    } else if (this.selectedFromConversion == 'centimeters' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * .00001;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 39.37007874;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * 3.280839895;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * 1.0936132983;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * 0.00062137119224;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 100;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'meters' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * .001;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'inches') {
      this.toResult = this.fromInput * 39370.07874;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'feet') {
      this.toResult = this.fromInput * 3280.839895;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'yards') {
      this.toResult = this.fromInput * 1093.6132983;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'miles') {
      this.toResult = this.fromInput * 0.62137119224;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'centimeters') {
      this.toResult = this.fromInput * 100000;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'meters') {
      this.toResult = this.fromInput * 1000;
    } else if (this.selectedFromConversion == 'kilometers' && this.selectedToConversion == 'kilometers') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'acres' && this.selectedToConversion == 'acres') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'acres' && this.selectedToConversion == 'squaremiles') {
      this.toResult = this.fromInput * 0.0015625;
    } else if (this.selectedFromConversion == 'acres' && this.selectedToConversion == 'squarekilometers') {
      this.toResult = this.fromInput * 0.0040468564224;
    } else if (this.selectedFromConversion == 'squaremiles' && this.selectedToConversion == 'acres') {
      this.toResult = this.fromInput * 640;
    } else if (this.selectedFromConversion == 'squaremiles' && this.selectedToConversion == 'squaremiles') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'squaremiles' && this.selectedToConversion == 'squarekilometers') {
      this.toResult = this.fromInput * 2.5899881103;
    } else if (this.selectedFromConversion == 'squarekilometers' && this.selectedToConversion == 'acres') {
      this.toResult = this.fromInput * 247.1053814672;
    } else if (this.selectedFromConversion == 'squarekilometers' && this.selectedToConversion == 'squaremiles') {
      this.toResult = this.fromInput * 0.386102159;
    } else if (this.selectedFromConversion == 'squarekilometers' && this.selectedToConversion == 'squarekilometers') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'fluidounces' && this.selectedToConversion == 'fluidounces') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'fluidounces' && this.selectedToConversion == 'quarts') {
      this.toResult = this.fromInput * 0.03125;
    } else if (this.selectedFromConversion == 'fluidounces' && this.selectedToConversion == 'gallons') {
      this.toResult = this.fromInput * 0.0078125;
    } else if (this.selectedFromConversion == 'quarts' && this.selectedToConversion == 'fluidounces') {
      this.toResult = this.fromInput * 32;
    } else if (this.selectedFromConversion == 'quarts' && this.selectedToConversion == 'quarts') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'quarts' && this.selectedToConversion == 'gallons') {
      this.toResult = this.fromInput * 0.25;
    } else if (this.selectedFromConversion == 'gallons' && this.selectedToConversion == 'fluidounces') {
      this.toResult = this.fromInput * 128;
    } else if (this.selectedFromConversion == 'gallons' && this.selectedToConversion == 'quarts') {
      this.toResult = this.fromInput * 4;
    } else if (this.selectedFromConversion == 'gallons' && this.selectedToConversion == 'gallons') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'ounces' && this.selectedToConversion == 'ounces') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'ounces' && this.selectedToConversion == 'pounds') {
      this.toResult = this.fromInput * 0.0625;
    } else if (this.selectedFromConversion == 'ounces' && this.selectedToConversion == 'grams') {
      this.toResult = this.fromInput * 28.349523125;
    } else if (this.selectedFromConversion == 'ounces' && this.selectedToConversion == 'kilograms') {
      this.toResult = this.fromInput * 0.028349523125;
    } else if (this.selectedFromConversion == 'pounds' && this.selectedToConversion == 'ounces') {
      this.toResult = this.fromInput * 16;
    } else if (this.selectedFromConversion == 'pounds' && this.selectedToConversion == 'pounds') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'pounds' && this.selectedToConversion == 'grams') {
      this.toResult = this.fromInput * 453.59237;
    } else if (this.selectedFromConversion == 'pounds' && this.selectedToConversion == 'kilograms') {
      this.toResult = this.fromInput * 0.45359237;
    } else if (this.selectedFromConversion == 'grams' && this.selectedToConversion == 'ounces') {
      this.toResult = this.fromInput * 0.03527396194958;
    } else if (this.selectedFromConversion == 'grams' && this.selectedToConversion == 'pounds') {
      this.toResult = this.fromInput * 0.0022046226218488;
    } else if (this.selectedFromConversion == 'grams' && this.selectedToConversion == 'grams') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'grams' && this.selectedToConversion == 'kilograms') {
      this.toResult = this.fromInput * 0.001;
    } else if (this.selectedFromConversion == 'kilograms' && this.selectedToConversion == 'ounces') {
      this.toResult = this.fromInput * 35.27396194958;
    } else if (this.selectedFromConversion == 'kilograms' && this.selectedToConversion == 'pounds') {
      this.toResult = this.fromInput * 2.2046226218488;
    } else if (this.selectedFromConversion == 'kilograms' && this.selectedToConversion == 'grams') {
      this.toResult = this.fromInput * 1000;
    } else if (this.selectedFromConversion == 'kilograms' && this.selectedToConversion == 'kilograms') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'farenheit' && this.selectedToConversion == 'farenheit') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'farenheit' && this.selectedToConversion == 'celsius') {
      this.toResult = (this.fromInput - 32) * (5 / 9);
    } else if (this.selectedFromConversion == 'celsius' && this.selectedToConversion == 'farenheit') {
      this.toResult = (this.fromInput * (9 / 5)) + 32;
    } else if (this.selectedFromConversion == 'celsius' && this.selectedToConversion == 'celsius') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'poundsper1000ft²' && this.selectedToConversion == 'poundsper1000ft²') {
      this.toResult = this.fromInput * 1;
    } else if (this.selectedFromConversion == 'poundsper1000ft²' && this.selectedToConversion == 'poundsperacre') {
      this.toResult = this.fromInput * 43.560;
    } else if (this.selectedFromConversion == 'poundsperacre' && this.selectedToConversion == 'poundsper1000ft²') {
      this.toResult = this.fromInput * 0.022956841138659;
    } else if (this.selectedFromConversion == 'poundsperacre' && this.selectedToConversion == 'poundsperacre') {
      this.toResult = this.fromInput * 1;
    }
  }

  HideFailureNotice() {
    this.displayFailure = false;
    this.failureMessage = "";
  }

}
